module.exports = __webpack_public_path__ + "img/CM-SL-CA-Lincoln-Playful.82958218.jpeg";